import React from 'react';
import cn from 'classnames';
import { Grid, GridItem } from 'components/UI/Grid';
import Card from 'components/cards/Card';
import * as styles from './cards.module.scss';

export function Component({ content, className }) {
  return (
    <div className={cn(className, styles.wrapper)}>
      <Grid sm={{ cols: 1 }} md={{ cols: 2 }} lg={{ cols: 3 }} xl={{ cols: 3 }}>
        {content.map(({ title, subtitle, list, secondDescription }) => (
          <GridItem key={title}>
            <Card
              title={title}
              subtitle={subtitle}
              list={list}
              secondDescription={secondDescription}
              theme="withShadow"
            />
          </GridItem>
        ))}
      </Grid>
    </div>
  );
}
